/**
 * BILA SIDEBAR FILTER
 */
jQuery(document).ready(function($) {
    'use strict';
    
    // Toggle filter sidebar on mobile
    $('.theme-product-filter-toggle').on('click', function() {
        $('.product-filter-form-wrapper').toggleClass('active');
        $('body').toggleClass('filter-sidebar-open');
    });
    
    // Close filter sidebar
    $('.edublink-filter-close-trigger a').on('click', function() {
        $('.product-filter-form-wrapper').removeClass('active');
        $('body').removeClass('filter-sidebar-open');
    });
    
    // Close sidebar when clicking outside on mobile
    $(document).on('click', function(e) {
        if ($(window).width() <= 991) {
            if (!$(e.target).closest('.filter-sidebar-column').length && 
                !$(e.target).closest('.theme-product-filter-toggle').length) {
                $('.product-filter-form-wrapper').removeClass('active');
                $('body').removeClass('filter-sidebar-open');
            }
        }
    });
    
    // Add active state to clicked filters
    $('.edublink-radio-filter, .edublink-checkbox-filter').on('click', function() {
        $(this).addClass('active').siblings().removeClass('active');
    });
    
    // Show selected count for checkboxes
    function updateSelectedCount() {
        $('.filter-widget').each(function() {
            var $widget = $(this);
            var selectedCount = $widget.find('input[type="checkbox"]:checked').length;
            
            if (selectedCount > 0) {
                var $title = $widget.find('.widget-title');
                if (!$title.find('.selected-count').length) {
                    $title.append('<span class="selected-count"> (' + selectedCount + ')</span>');
                } else {
                    $title.find('.selected-count').text(' (' + selectedCount + ')');
                }
            } else {
                $widget.find('.selected-count').remove();
            }
        });
    }
    
    // Update count on checkbox change
    $(document).on('change', 'input[type="checkbox"]', function() {
        updateSelectedCount();
    });
    
    // Initial update
    updateSelectedCount();
    

    
    // Add keyboard navigation
    $(document).on('keydown', function(e) {
        // ESC to close filter sidebar
        if (e.keyCode === 27 && $('.product-filter-form-wrapper').hasClass('active')) {
            $('.product-filter-form-wrapper').removeClass('active');
            $('body').removeClass('filter-sidebar-open');
        }
    });

});